module.exports = __webpack_public_path__ + "img/sankaku_54_red.933bffff.png";